import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useMarkORderInProgress, useSendComments } from "./store";
import FalconCloseButton from "modules/common/FalconCloseButton";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { canNotMarkStatusProgress } from "modules/utilities/utility";

function HandleBackOperation({ order, customer }) {
  const [show, setShow] = React.useState(false);
  const { orderInProgress } = useMarkORderInProgress();
  const [comment, setComment] = useState("");
  const { sendComment } = useSendComments();
  const { setToaster } = useToast();

  const handleClose = () => {
    setShow(false);
    setComment("");
  };
  const handleShow = () => setShow(true);

  const handleAssignBack = async () => {
    orderInProgress(order?.id, toast);
    await sendComment(customer?.id, comment, setToaster);
    handleClose();
  };

  return (
    <>
      <Button
        variant="info"
        className={`${
          canNotMarkStatusProgress.includes(order?.status) ? "disabled" : ""
        }`}
        onClick={handleShow}
      >
        Send back to Operation
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Comment for send back to operation</Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Enter comment</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAssignBack}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default HandleBackOperation;
